import { DiagnosticsApi } from "~/api/Diagnostics";

export function useDiagnosticsApi(): DiagnosticsApi {
  const diagnosticsApi = new DiagnosticsApi(useHttpClient());

  return diagnosticsApi;
}